import { call, takeEvery, put } from 'redux-saga/effects';
import { createAction } from 'redux-actions';
import { API_REQUEST, UNAUTHORIZED } from 'constants/action-types';
import { addLoader, removeLoader } from 'components/common/loaders/loading-actions';
import FileSaver from 'file-saver';
import { store } from 'store';
import { history } from 'history-setup';

const defaultNextType = {
  pending: 'REQUEST_PENDING',
  success: 'REQUEST_SUCCESS',
  error: 'REQUEST_ERROR'
};

function* fetchData(action) {
  const state = store.getState();
  const nextType = action.payload.nextActionType || defaultNextType;
  const loaderId = nextType.pending.replace(/([\w]+)_PENDING$/, '$1');

  yield put(
    createAction(
      nextType.pending,
      () => action.payload,
      () => action.meta
    )()
  );
  let status = -1;
  try {
    const isExternal = action.meta && action.meta.isExternal;
    const url = isExternal ? action.payload.url : `${CONFIG.API_BASE_URL}${action.payload.url}`;
    const body = action.payload.data;
    const isUpload = action.payload.files;
    const isDownload = action.meta && action.meta.downloadFileName;
    const headers =
      isUpload || isExternal
        ? {}
        : {
            'content-type': 'application/json'
          };
    if (state.site.tokenData && !isExternal)
      headers.Authorization = `Bearer ${state.site.tokenData.accessToken}`;
    const filesData = new FormData();
    if (isUpload) {
      filesData.append('files', action.payload.files);
    }
    let dataToSend;
    if (isUpload) {
      dataToSend = filesData;
    } else if (isExternal) {
      dataToSend = action.payload.data;
      headers['Content-Type'] = action.payload.data.type;
    } else {
      dataToSend = JSON.stringify(body);
    }
    if (action.meta && action.meta.hasLoader) {
      yield put(addLoader(loaderId));
    }

    const request = yield call(fetch, url, {
      method: action.payload.method || 'GET',
      headers,
      body: dataToSend
    });

    if (request.status === 401) {
      yield put(createAction(UNAUTHORIZED)());
      history.push('/login');
      window.location.reload();
      throw UNAUTHORIZED;
    }

    status = request.status;

    let fetchResult;
    if (isDownload && request.ok) {
      const fileData = yield request.json();
      const byteCharacters = window.atob(fileData.fileBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/vnd.ms-excel' });
      yield FileSaver.saveAs(blob, fileData.fileName);
      fetchResult = blob;
    } else if (isExternal) {
      fetchResult = yield request.text();
    } else {
      fetchResult = yield request.json();
    }

    if (fetchResult) {
      if (action.meta && action.meta.hasLoader) {
        yield put(removeLoader(loaderId));
      }
      if (fetchResult.errorMessage) throw fetchResult.errorMessage;
      if (fetchResult.errors && fetchResult.errors.length) throw fetchResult.errors;
    }

    yield put(
      createAction(
        nextType.success,
        () => fetchResult,
        () => action.meta
      )(fetchResult)
    );

    if (action.payload.additionalActions) {
      // eslint-disable-next-line no-restricted-syntax
      for (const a of action.payload.additionalActions) {
        yield put(a);
      }
    }
  } catch (e) {
    if (action.meta && action.meta.hasLoader) {
      yield put(removeLoader(loaderId));
    }
    yield put(
      createAction(
        nextType.error,
        () => e,
        () => (!status !== -1 ? { ...action.meta, status } : action.meta)
      )(e)
    );
  }
}

export default function* apiSaga() {
  yield takeEvery(API_REQUEST, fetchData);
}
